document.querySelectorAll('.js-link').forEach(function (element) {
  element.addEventListener('click', function (e) {
    e.stopPropagation();
    e.preventDefault();
    location.href = this.getAttribute('data-url');
  });
});
